import React from "react";
import PropTypes from "prop-types";
import { Box, Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ACCENT, ACCENT_DARK } from "./assessmentTheme";
import { TAB_ICONS } from "./assessmentNav";

function AssessmentHeader({ title, groupLabel, icon, crumbs }) {
  return (
    <Box
      sx={{
        borderRadius: "16px",
        p: { xs: 2, md: 2.5 },
        mb: 2,
        color: "#fff",
        background: `linear-gradient(120deg, ${ACCENT_DARK} 0%, ${ACCENT} 55%, #3b6fd4 100%)`,
        boxShadow: "0 8px 24px rgba(23,71,158,0.22)",
        display: "flex",
        alignItems: "center",
        gap: 2,
        textAlign: "left",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "12px",
          display: { xs: "none", sm: "flex" },
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255,255,255,0.16)",
          "& svg": { fontSize: 24 },
        }}
      >
        {icon || TAB_ICONS[title]}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{ "& .MuiBreadcrumbs-separator": { color: "rgba(255,255,255,0.6)" } }}
        >
          {crumbs || [
            <Link key="books" to="/booklist" style={{ color: "rgba(255,255,255,0.8)", textDecoration: "none", fontSize: "0.78rem" }}>
              Books List
            </Link>,
            <Typography key="assessment" sx={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.8)" }}>
              Assessment
            </Typography>,
            groupLabel && (
              <Typography key="group" sx={{ fontSize: "0.78rem", color: "#fff", fontWeight: 600 }}>
                {groupLabel}
              </Typography>
            ),
          ]}
        </Breadcrumbs>
        <Typography sx={{ fontWeight: 800, fontSize: { xs: "1.25rem", md: "1.5rem" }, lineHeight: 1.25 }}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
}

AssessmentHeader.propTypes = {
  title: PropTypes.string.isRequired,
  groupLabel: PropTypes.string,
  icon: PropTypes.node,
  crumbs: PropTypes.node,
};

export default AssessmentHeader;
